import { render, staticRenderFns } from "./RegisteredStudentsModal.vue?vue&type=template&id=43546594&"
import script from "./RegisteredStudentsModal.vue?vue&type=script&lang=js&"
export * from "./RegisteredStudentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports